//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/button'
import 'devextreme/ui/popover'
import 'devextreme/ui/select_box'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { CommonHelper } from '../../../helpers/common-helper'
import { FileModel } from '../../api/api.models'
import { i18n } from '../../common/i18n/common.i18n'
import { FileUploaderOptions } from '../file-uploader/file-uploader.directive'

import { TemplateHelper, ConfigHelper, IUserSession } from '../../../helpers'

//#region Asset Imports

import './select-add-file.scss'
import * as TEMPLATE from './select-add-file.tpl.html'

//#endregion

export interface SelectAddFileScope extends ng.IScope {
    selectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    addNewFileButtonOptions: DevExpress.ui.dxButtonOptions
    fileUploaderPopoverOptions: DevExpress.ui.dxPopoverOptions

    selectBox: DevExpress.ui.dxSelectBox
    addNewFileButton: DevExpress.ui.dxButton
    fileUploaderPopover: DevExpress.ui.dxPopover

    fileUploaderOptions: FileUploaderOptions

    elementId: number
    currentId: number
    indexNbr: number
    propertyName: string
    files: FileModel[]
    callback: (elementId: number, propertyName: string, value: FileModel) => void
}

export class SelectAddFileDirective implements ng.IDirective {
    readedBytes: any[]
    fileName: string
    isPopoverOpened: boolean

    constructor() { }

    restrict = 'E'

    scope = {
        elementId: '=',
        currentId: '=',
        indexNbr: '=',
        propertyName: '@',
        files: '=',
        callback: '=',
        addNewCallback: '='
    }

    controller = ['$scope', '$q', '$timeout', 'api', 'localDictionary', 'userSession', ($scope: SelectAddFileScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, localDictionary: LocalDictionaryFactory, userSession: IUserSession) => {
        $scope.fileUploaderOptions = <FileUploaderOptions>{
            acceptValue: CommonHelper.fileExtensionsToMediaTypes(['png', 'jpg', 'svg', 'jpeg']),
            uploaderVisible: true,
            resetAfterReadEnd: true,
            onReadEnd: (reader, fileName) => {

                var fileExtension = CommonHelper.getFileExtension(fileName)
                let readedBytes: string[] = reader.result.split(',')

                let fileBytes = readedBytes.slice(1).join(',')

                let newFile = <FileModel>{
                    extension: fileExtension,
                    fileBytesObj: fileBytes,
                    id: getNewIdFile(),
                    physicalFileName: fileName,
                    opState: CommonHelper.ChangeState.New
                }

                if (!$scope.files)
                    $scope.files = []

                $scope.files.push(newFile)

                $scope.selectBox.option('value', newFile.id)

                this.isPopoverOpened = false
                $scope.fileUploaderPopover.toggle(this.isPopoverOpened)
            },
            onSubmitClick: () => {

            }
        }

        $scope.fileUploaderPopoverOptions = {
            target: '#newFileButton' + $scope.indexNbr,
            height: 300,
            width: 350,
            onInitialized: e => {
                $scope.fileUploaderPopover = e.component
            },
            onHidden: e => {
                this.isPopoverOpened = false
            }
        }

        $scope.selectBoxOptions = {
            noDataText: i18n('Common', 'NoData'),
            placeholder: i18n('Common', 'Select'),
            onInitialized: e => {
                $scope.selectBox = e.component
            },
            bindingOptions: {
                items: 'files'
            },
            value: $scope.currentId,
            valueExpr: 'id',
            displayExpr: 'physicalFileName',
            onSelectionChanged: e => {
                if ($scope.callback)
                    $scope.callback($scope.elementId, $scope.propertyName, e.selectedItem)
            },
            showClearButton: true
        }

        $scope.addNewFileButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.ATTACH_FILE, userSession),
            hint: i18n('Common', 'NewFile'),
            onInitialized: e => {
                $scope.addNewFileButton = e.component
            },
            onClick: e => {
                this.isPopoverOpened = !this.isPopoverOpened
                $scope.fileUploaderPopover.toggle(this.isPopoverOpened)
            }
        }

        const getNewIdFile = () => {
            if (!$scope.files) $scope.files = []
            const fileIds = $scope.files.map(file => file.id)
            fileIds.push(1000000)

            return Math.max(...fileIds) + 1
        }
    }]
    template = TEMPLATE
    transclude = true
}